import { useEffect, useRef } from 'react'

const useSaved = <T>(value: T) => {
  const ref = useRef<T>(value)

  useEffect(() => {
    if (value != null) {
      ref.current = value
    }
  }, [value])

  return value ?? ref.current
}

export default useSaved
